import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-notification-card',
  templateUrl: './notification-card.component.html',
  styleUrls: ['./notification-card.component.scss'],
})
export class NotificationCardComponent {
  @Input() type: string = '';
  @Input() text: string = '';
  @Input() header: string = '';
  @Input() description: string = '';
  @Input() link: string = '';
  @Input() toolTip: string = '';
  @Output() linkClicked = new EventEmitter();

  Types = {
    ERROR: 'error',
    INFO: 'info',
    DEFAULT: 'default',
    CSC: 'csc',
    OUTAGE: 'outage',
    WARN: 'warn',
  };
}
